import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {Search, Close} from '@mui/icons-material'

const Container = styled.div`
    background-color: rgba(160, 183, 190, .24);
    border-radius: 2px;
    height: 40px;
    width: 320px;
    align-items: center;
    display: flex;
    transition: background-color .3s cubic-bezier(.55, 0, .1, 1);

    :focus-within {
        background-color: rgba(160, 183, 190, .35);
    }

    input {
        width: 100%;
        height: 100%;
        padding: 0;

        ::placeholder {
            font-style: italic;
        }
    }

	svg {
		font-size: 20px;
        margin: 0 12px;
        cursor: pointer;
	}
`

const Field = injectIntl(({value, onChange, onClick, intl, style, forwardRef}) => (
	<Container style={style}>
		<Search />
		<input
			ref={forwardRef}
			defaultValue={value}
			placeholder={intl.formatMessage({id: "table.search"})}
			onChange={onChange}
		/>
		{value &&
			<Close onClick={onClick} />
		}
	</Container>
))

export default React.memo(React.forwardRef((props, ref) => <Field forwardRef={ref} {...props} />))
